import { render, staticRenderFns } from "./index.vue?vue&type=template&id=284b95d5&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=284b95d5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b95d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284b95d5')) {
      api.createRecord('284b95d5', component.options)
    } else {
      api.reload('284b95d5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=284b95d5&scoped=true", function () {
      api.rerender('284b95d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopee-product/index.vue"
export default component.exports